import React, { PureComponent } from 'react';

import { translate } from 'components/translate';
import { PropTypes } from 'prop-types';

import ChecklistItem from './ChecklistItem';

@translate()
export default class ChecklistSelectAll extends PureComponent {
  static defaultProps = {
    text: 'module_editor.select_all'
  };

  static propTypes = {
    items: PropTypes.array,
    checklistId: PropTypes.string,
    onChange: PropTypes.func,
    text: PropTypes.string,
    t: PropTypes.func,
    name: PropTypes.string
  };

  get isAllChecked() {
    const { items } = this.props;
    const checkedItems = items.filter((item) => item.checked);

    return checkedItems.length === items.length;
  }

  render() {
    const { text, t, onChange, checklistId, name, ...props } = this.props;

    return (
      <ChecklistItem
        {...props}
        name={name}
        className="checklist__item__select__all"
        onChange={onChange}
        id={`checklist__${checklistId}__item__select__all`}
        key={`checklist__${checklistId}__item__select__all`}
        item={{
          name: t(text),
          value: 'select__all',
          checked: this.isAllChecked
        }}
      />
    );
  }
}
